module.exports = __webpack_public_path__ + "img/weekend-pause-background.88d20487.png";